import React from "react";
import CheckStatus from '../../components/payment/checkStatus';
export default CheckStatus;